import type { DealStage } from '@/types'

export const PLATAFORMA_REQUIRED_MESSAGE =
  'Informe a plataforma da loja no resumo do negócio antes de enviar a proposta.'

export function hasDealPlataforma(plataforma?: string | null): boolean {
  return Boolean(plataforma?.trim())
}

export function blocksPropostaEnviada(
  from: DealStage,
  to: DealStage,
  plataforma?: string | null,
): boolean {
  return to === 'proposta_enviada' && from !== 'proposta_enviada' && !hasDealPlataforma(plataforma)
}
